// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1aeN7","col":"styles_col__232xe"};